import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px;
  height: 150px;
  width: 310px;
`;

export const ButtonRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
  width: 100%;
`;

export const UpdateLabel = styled.label`
  margin-bottom: 4px;
`;

export const UpdateInput = styled.input`
  padding: 6px;
  font-size: 14px;
`;